import styled, { css } from 'styled-components'
import { inputStyles, InputLabel, InputStyleProps } from 'components/generic/Input/styles'
import { LABEL_POSITION } from 'components/generic/Input/TextInput'

export const Input = styled.input<InputStyleProps>`
  ${inputStyles}
`

const inlineLabelStyles = css`
  display: flex;
  align-items: center;

  & > span {
    font-weight: normal;
    margin-bottom: 0;
  }

  & > input {
    width: auto;
  }
`

const labelLeftStyles = css`
  & > span {
    order: 0;
    margin-right: 0.5rem;
  }
  ${inlineLabelStyles}
`

const labelRightStyles = css`
  & > span {
    order: 1;
    margin-left: 0.5rem;
  }
  ${inlineLabelStyles}
`

export const Label = styled(InputLabel)<{ labelPosition: string }>`
  ${({ labelPosition }) => {
    switch (labelPosition) {
      case LABEL_POSITION.RIGHT:
        return labelRightStyles
      case LABEL_POSITION.LEFT:
        return labelLeftStyles
    }
  }}
`
